module.exports = __webpack_public_path__ + "media/images/countryrect/gf-2810a2b85014bd8f1bcd72e54f7342ab.svg";